<template>
  <el-button type="primary" size="mini" plain @click="pushView">
    View
  </el-button>
</template>

<script>
export default {
  props: {
    product: Object,
  },
  methods: {
    pushView() {
      window.open(`${ process.env.VUE_APP_APP_HOST }/store/${ this.product.slug }~${ this.product.variants[0].id }`)
    }
  }
}
</script>
